module.exports = __webpack_public_path__ + "img/start-1.7be6cf08.png";